import ReactInputMask from 'react-input-mask';
import styled from 'styled-components';

export const StyledMaskedInput = styled(ReactInputMask)`
  width: ${(props) => (props.width ? `${props.width}px` : '100%')};
  height: ${(props) => (props.height ? `${props.height}px` : '35px')};
  font-weight: ${(props) => props.fontWeight};
  border: 1px solid ${(props) => props.theme.colors.gray100};
  border-radius: ${(props) => props.theme.radii.xs};
  padding: 0 8px;
  color: ${(props) => props.theme.colors.gray450};
  font-size: 0.875rem;
  &:focus {
    outline: 1px solid #80bdff !important;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
  &:disabled {
    background-color: #f6f7f9;
    cursor: not-allowed;
  }
`;
